import { IUser, IUserState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import { updateObject } from '../../utilities/utilities';
import {
  IAddUserSuccess,
  IAuthSuccess,
  IChangePasswordSuccess,
  IDeleteUserSuccess,
  IFetchUsersSuccess,
  IUpdateUserChallengeAndSession,
  IUpdateUserSuccess,
  IUserAction
} from '../actions/userActions';
export const initialUserState: IUserState = {
  users: [],
  isFetching: false,
  userInfo: undefined,
  token: '',
  authStatus: 0
};

const processUser = (user: any): IUser => {
  return {
    userId: user.user_id,
    name: user.name,
    email: user.email,
    role: user.role,
    screens: user.screens ? user.screens : [],
    status: user.is_active,
    // jiraUserName: user.jira_user_name ? user.jira_user_name : '',
    refresh_token: user.refresh_token,
    access_token: user.access_token,
    token: user.token,
    session: '',
    challenge: ''
  };
};

const processUsers = (users: any): IUser[] => {
  const result: IUser[] = [];
  for (const user of users) {
    result.push(processUser(user));
  }
  return result;
};

const fetchUserSuccess = (state: IUserState, action: IFetchUsersSuccess) => {
  const updatedState: IUserState = JSON.parse(JSON.stringify(state));
  updatedState.isFetching = false;
  updatedState.users = processUsers(action.payload);
  return { ...state, ...updatedState };
};

const fetchUserPending = (state: IUserState) => {
  const updatedState: IUserState = JSON.parse(JSON.stringify(state));
  updatedState.isFetching = true;
  return { ...state, ...updatedState };
};

const authSuccess = (state: IUserState, action: IAuthSuccess) => {
  const updatedState: IUserState = JSON.parse(JSON.stringify(state));
  const payload: any = action.payload;
  updatedState.userInfo = processUser(payload);
  updatedState.token = payload.token;
  updatedState.authStatus = 1;
  updatedState.session = '';
  updatedState.challenge = '';
  return updateObject(state, updatedState);
};

const authLogout = (state: IUserState) => {
  return updateObject(state, {
    userInfo: undefined,
    token: '',
    authStatus: -1,
    assets: [],
    feeds: [],
    filters: [],
    screens: []
  });
};

const addUserSuccess = (state: IUserState, action: IAddUserSuccess) => {
  const updatedState: IUserState = JSON.parse(JSON.stringify(state));
  const payload: any = action.payload;
  updatedState.users.push({
    userId: payload.user_id,
    name: payload.name,
    email: payload.email,
    role: payload.role,
    screens: payload.screens,
    status: payload.is_active
    // jiraUserName: payload.jira_user_name ? payload.jira_user_name : ''
  });
  return { ...state, ...updatedState };
};

const updateUserSuccess = (state: IUserState, action: IUpdateUserSuccess) => {
  const updatedState: IUserState = JSON.parse(JSON.stringify(state));
  const users = updatedState.users;
  for (const i in users) {
    if (users[i].userId === action.payload.user_id) {
      users[i] = processUser(action.payload);
      break;
    }
  }
  return updateObject(state, updatedState);
};

const deleteUserSuccess = (state: IUserState, action: IDeleteUserSuccess) => {
  const userId: string = action.userId;
  const updatedState: IUserState = JSON.parse(JSON.stringify(state));
  updatedState.users = updatedState.users.filter(user => {
    return user.userId !== userId;
  });
  return { ...state, ...updatedState };
};

const updateUserSessionAndChallenge = (
  state: IUserState,
  action: IUpdateUserChallengeAndSession
) => {
  const updatedState: IUserState = JSON.parse(JSON.stringify(state));

  updatedState.challenge = action.payload.ChallengeName;
  updatedState.session = action.payload.Session;

  return { ...state, ...updatedState };
};

const changePassword = (state: IUserState, action: IChangePasswordSuccess) => {
  return state;
};

const userReducer = (
  state = initialUserState,
  action: IUserAction
): IUserState => {
  switch (action.type) {
    case actionTypes.FETCH_USERS_SUCCESS:
      return fetchUserSuccess(state, action);
    case actionTypes.FETCH_USERS_PENDING:
      return fetchUserPending(state);
    case actionTypes.DELETE_USER_SUCCESS:
      return deleteUserSuccess(state, action);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state);
    case actionTypes.ADD_USER_SUCCESS:
      return addUserSuccess(state, action);
    case actionTypes.UPDATE_USER_SUCCESS:
      return updateUserSuccess(state, action);
    case actionTypes.UPDATE_USER_CHALLENGE_AND_SESSION:
      return updateUserSessionAndChallenge(state, action);
    case actionTypes.CHANGE_PASSWORD_SUCCESS:
      return changePassword(state, action);
    default:
      return state;
  }
};

export default userReducer;
